export const handleChangeDataSearchBranchAutoComplete = (name, value) => ({
    type: 'CHANGE_DATA_SEARCH_BRANCH_AUTOCOMPLETE', name, value
});